export const FILE_INPUT_ICON_WIDTH = 24;
export const FILE_INPUT_ICON_HEIGHT = 24;
export const FILE_INPUT_DISABLED_LOADER_COLOR = "color-neutral-shade-80";
export const FILE_INPUT_LOADER_COLOR = "color-neutral-shade-80";
export const FILE_INPUT_HIGHLIGHTED_CLASS = "highlighted";
